import { Injectable } from '@angular/core';
import { Chart } from 'chart.js';

// npm install chart.js --save
/*
  ts:
  
    import { Component, ElementRef, OnInit,  } from '@angular/core';
    
    chart;

    xLabels : Array<string> = ["Das", "ist", "ein", "Array", "mit", "Labels"];
    yLabel  : string        = 'Summe in €';
    data    : Array<number> = [1200, 1190, 1300, 1500, 1120, 1300];
    
    constructor( private elementRef: ElementRef, private chartService: ChartService ) {}
  
    ngOnInit() {
      let id      = 'canvas';
      let htmlRef = this.elementRef.nativeElement.querySelector(`#` + id);
    
      this.chart = this.chartService.createChart( id, this.xLabels, this.yLabel, this.data);
    }
    
  html: 
    <div style="margin-left: 300px; margin-top: 100px; position: relative; width: 500px !important; height:500px !important;">
      <canvas id="canvas" width="400" height="400">{{chart}}</canvas>
    </div>
*/


export class ChartService {
  
  constructor() {}
  
  createChart(id : string, xLabels : Array<string>, yLabel : string, data : Array<number>, bgC ){
    bgC.forEach(element => {
      element
    });
    
    
    return new Chart( id, {
      type: 'bar',
      data: {
        labels: xLabels,
        datasets: [{
          label: yLabel,
          data: data,
          backgroundColor: bgC,
          borderColor: bgC,
          borderWidth: 1
        }]
      },
      display: false,
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero:true
              }
            }]
          }
        }
    });
  
  }

}


// WEBPACK FOOTER //
// ./src/app/chart.service.ts